import * as React from 'react';
import { memo } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import { OptionTypeBase } from 'react-select';

import { ErrorsType, TeacherIEType, TeacherHireType } from 'types';

import { InputLabel, ISelectOption, TextArea, Input } from 'atoms';

export interface IIeFieldsValues extends Partial<TeacherIEType> {}

export interface IIeFields {
  values?: IIeFieldsValues;
  disableFields?: boolean;
  index: number;
  errors?: ErrorsType<IIeFieldsValues> | null;
  onInputChange: (
    name: string,
    value?: string | boolean | ISelectOption<string> | null | OptionTypeBase,
  ) => void;
}

export const IeFields = memo(
  ({ values, disableFields, index, errors, onInputChange }: IIeFields) => {
    const { t } = useTranslation();
    const name = `teacherTypes[${index}].${TeacherHireType.Ie}`;
    return (
      <>
        <div>
          <InputLabel>{t('teacherTypePopup.ieFields.inn.label')}</InputLabel>
          <Input
            placeholder={t('teacherTypePopup.ieFields.inn.placeholder')}
            max={100}
            type="text"
            value={values?.inn || ''}
            name={`${name}.inn`}
            onChange={({ target: { value } }) =>
              onInputChange(`${name}.inn`, value)
            }
            hasError={Boolean(errors?.inn)}
            disabled={disableFields}
          />
        </div>
        <div>
          <InputLabel>
            {t('teacherTypePopup.ieFields.accountNumber.label')}
          </InputLabel>
          <Input
            placeholder={t(
              'teacherTypePopup.ieFields.accountNumber.placeholder',
            )}
            max={100}
            type="text"
            value={values?.accountNumber || ''}
            name={`${name}.accountNumber`}
            onChange={({ target: { value } }) =>
              onInputChange(`${name}.accountNumber`, value)
            }
            hasError={Boolean(errors?.accountNumber)}
            disabled={disableFields}
          />
        </div>
        <div>
          <InputLabel>{t('teacherTypePopup.ieFields.bic.label')}</InputLabel>
          <Input
            placeholder={t('teacherTypePopup.ieFields.bic.placeholder')}
            max={100}
            type="text"
            value={values?.bic || ''}
            name={`${name}.bic`}
            onChange={({ target: { value } }) =>
              onInputChange(`${name}.bic`, value)
            }
            hasError={Boolean(errors?.bic)}
            disabled={disableFields}
          />
        </div>
        <div>
          <InputLabel>
            {t('teacherTypePopup.ieFields.bankTitle.label')}
          </InputLabel>
          <Input
            placeholder={t('teacherTypePopup.ieFields.bankTitle.placeholder')}
            max={100}
            type="text"
            value={values?.bankTitle || ''}
            name={`${name}.bankTitle`}
            onChange={({ target: { value } }) =>
              onInputChange(`${name}.bankTitle`, value)
            }
            hasError={Boolean(errors?.bankTitle)}
            disabled={disableFields}
          />
        </div>
        <TextAreaWrapper>
          <InputLabel>
            {t('teacherTypePopup.ieFields.registrationAddress.label')}
          </InputLabel>
          <TextArea
            placeholder={t(
              'teacherTypePopup.ieFields.registrationAddress.placeholder',
            )}
            rows={1}
            value={values?.registrationAddress || ''}
            name={`${name}.registrationAddress`}
            onChange={({ target: { value } }) =>
              onInputChange(`${name}.registrationAddress`, value)
            }
            hasError={Boolean(errors?.registrationAddress)}
            disabled={disableFields}
          />
        </TextAreaWrapper>
      </>
    );
  },
);

const TextAreaWrapper = styled.div`
  grid-column-start: 1;
  grid-column-end: 3;
`;
